// extracted by mini-css-extract-plugin
export default {"palletTableRow":"DistributionCenterPalletsTableItem_palletTableRow__jKdTk","tableCellOrder":"DistributionCenterPalletsTableItem_tableCellOrder__dznNm"};